import {PayloadAction} from "@reduxjs/toolkit";
import {Dispatch} from "react";
import {
    ConfirmPaymentSuccessRequest,
    PaymentRequest,
    PaymentResponse,
    RefundRequest,
    RefundResponse,
    PaymentListResponse,
    PaymentIntent
} from "../../shared/entities/Stripe/Stripe";
import {StripeRepositoryInstance} from "../../repository/Stripe/StripeRepository";

// Если нужно добавить actions в Redux, создайте файл StripeReducer
// export const StripeActionTypes = {
//     SET_CLIENT_SECRET: 'SET_CLIENT_SECRET',
//     SET_PAYMENT_INTENT: 'SET_PAYMENT_INTENT',
//     CLEAR_PAYMENT: 'CLEAR_PAYMENT'
// };

/**
 * StripeService.
 *
 * Handles Stripe payment operations and dispatches actions to Redux store
 */
export class StripeService {
    private dispatch: Dispatch<PayloadAction<any>>
    private repository = StripeRepositoryInstance

    constructor(dispatch: Dispatch<PayloadAction<any>>) {
        this.dispatch = dispatch
    }

    /**
     * Create a payment intent
     */
    public async confirmPaymentSuccess(data: ConfirmPaymentSuccessRequest): Promise<PaymentResponse> {
        return this.repository.confirmPaymentSuccess(data).then(res => {
            return res.Some
        })
    }

    public async createPaymentIntent(data: PaymentRequest): Promise<PaymentResponse> {
        return this.repository.createPaymentIntent(data).then(res => {
            // Опционально: диспатчим clientSecret в Redux
            if (res.Some?.clientSecret) {
                // this.dispatch({
                //     type: StripeActionTypes.SET_CLIENT_SECRET,
                //     payload: res.Some.clientSecret
                // });
            }
            return res.Some
        })
    }

    /**
     * Get payment intent by ID
     */
    public async getPaymentIntent(id: string): Promise<PaymentIntent> {
        return this.repository.getPaymentIntent(id).then(res => {
            // Опционально: диспатчим payment intent в Redux
            if (res.Some) {
                // this.dispatch({
                //     type: StripeActionTypes.SET_PAYMENT_INTENT,
                //     payload: res.Some
                // });
            }
            return res.Some
        })
    }

    /**
     * Create a refund
     */
    public async createRefund(data: RefundRequest): Promise<RefundResponse> {
        return this.repository.createRefund(data).then(res => {
            return res.Some
        })
    }

    /**
     * List payments with pagination
     */
    public async listPayments(limit: number = 10, startingAfter?: string, endingBefore?: string): Promise<PaymentListResponse> {
        return this.repository.listPayments(limit, startingAfter, endingBefore).then(res => {
            return res.Some
        })
    }

    /**
     * Get refunds for a specific payment
     */
    public async getRefundsForPayment(paymentIntentId: string): Promise<RefundResponse[]> {
        return this.repository.getRefundsForPayment(paymentIntentId).then(res => {
            return res.Some
        })
    }

    /**
     * Search payments by email
     */
    public async searchPaymentsByEmail(email: string, limit: number = 50): Promise<PaymentListResponse> {
        return this.repository.searchPaymentsByEmail(email, limit).then(res => {
            return res.Some
        })
    }

    /**
     * Clear payment data (optional)
     */
    public clearPaymentData(): void {
        // this.dispatch({
        //     type: StripeActionTypes.CLEAR_PAYMENT,
        //     payload: null
        // });
    }
}